export function buildModalShellTokens(dark, c, A) {
  const soft = (a) => `${A}${a}`;
  return {
    overlay: dark ? "rgba(0,0,0,0.5)" : "rgba(13, 15, 18, 0.32)",
    headerBg: dark
      ? "linear-gradient(180deg, rgba(255,255,255,0.04) 0%, transparent 100%)"
      : `linear-gradient(180deg, ${c.hdr ?? c.sb} 0%, ${c.bg} 100%)`,
    labelStrong: dark ? c.sub : c.mid,
    accentBar: `linear-gradient(90deg, ${A} 0%, ${soft("88")} 38%, transparent 78%)`,
    cardGradient: dark
      ? "linear-gradient(180deg, #13151C 0%, #0F1118 100%)"
      : "linear-gradient(180deg, #FFFFFF 0%, #FAFAF8 100%)",
    cardBorder: dark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)",
    cardShadowLg: dark
      ? "0 32px 96px rgba(0,0,0,.8), 0 8px 32px rgba(0,0,0,.4)"
      : "0 32px 96px rgba(0,0,0,.25), 0 8px 32px rgba(0,0,0,.1)",
  };
}
